import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { logger } from '@/features/help/utils/logger';

interface SignupFormState {
  name: string;
  email: string;
  password: string;
  companyName: string;
  agreedToTerms: boolean;
  setName: (name: string) => void;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  setCompanyName: (companyName: string) => void;
  setAgreedToTerms: (agreed: boolean) => void;
  resetForm: () => void;
}

export const useSignupFormStore = create<SignupFormState>()(
  persist(
    (set) => ({
      name: '',
      email: '',
      password: '',
      companyName: '',
      agreedToTerms: false,

      setName: (name) => set({ name }),
      setEmail: (email) => set({ email }),
      setPassword: (password) => set({ password }),
      setCompanyName: (companyName) => set({ companyName }),
      setAgreedToTerms: (agreedToTerms) => set({ agreedToTerms }),

      resetForm: () =>
        set({
          name: '',
          email: '',
          password: '',
          companyName: '',
          agreedToTerms: false,
        }),
    }),
    {
      name: 'bigtuna-signup-form',
      onRehydrateStorage: () => {
        logger.debug('SignupForm', 'Hydrating signup form data from persistent storage', {
          userId: 'system',
        });
      },
    }
  )
);
